import Icon from '../../components/Icon.vue'

Icon.register({"brands/pinterest-p":{"width":384,"height":512,"paths":[{"d":"M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296 73.5 296 79.2 268.4 79.2 260.6 79.2 251.3 55.5 231.5 55.5 192.8 55.5 112.4 116.7 55.4 195.9 55.4 264 55.4 314.4 94.1 314.4 165.2 314.4 218.3 293.1 317.9 224.1 317.9 199.2 317.9 177.9 299.9 177.9 274.1 177.9 236.3 204.3 199.7 204.3 160.7 204.3 94.5 110.4 106.5 110.4 186.5 110.4 203.3 112.5 221.9 120 237.2 106.2 296.6 78 385.1 78 446.3 78 465.2 80.7 483.8 82.5 502.7 85.9 506.5 84.2 506.1 89.4 504.2 139.8 435.2 138 421.7 160.8 331.4 173.1 354.8 204.9 367.4 230.1 367.4 336.3 367.4 384 263.9 384 170.6 384 71.3 298.2 6.5 204 6.5z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/brands/pinterest-p.js
// module id = null
// module chunks = 